var ERROR_MESSAGES = {
  "Unknown error An error occurred (UserNotFoundException) when calling the InitiateAuth operation: User does not exist.":
    "Nieprawidłowy e-mail lub hasło",
  "The username or password is incorrect": "Nieprawidłowy e-mail lub hasło",
  "Invalid Verification code": "Nieprawidłowy kod, spróbuj jeszcze raz.",
  "User with this email already exists":
    "Użytkownik z podanym adresem email już istnieje. Kliknij przycisk 'Mam już konto', aby się zalogować.",
  "Password did not conform with policy: Password not long enough":
    "Hasło jest za krótkie",
  "An error occurred (InvalidParameterException) when calling the SignUp operation: Invalid phone number format.":
    "Niewłaściwy format numeru telefonu. Numer telefonu powinien zawierać numer kierunkowy np. +48123456789",
  "An error occurred (InvalidParameterException) when calling the SignUp operation: 1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length less than or equal to 256":
    "Hasło musi mieć długość mniejszą bądź równą 256.",
  "Password should have Caps, Special chars, Numbers":
    "Hasło musi zawierać małą i dużą literę, znak specjalny (^$*.[]{}()?-\"!@#%&/\\,><':;|_~`+=) oraz cyfrę",
  "Invalid length for parameter Password":
    "Hasło musi mieć długość większą bądź równą 8.",
  "User is already confirmed":
    "Użytkownik został już potwierdzony. Zaloguj się.",
  "User is already confirmed.":
    "Użytkownik został już potwierdzony. Zaloguj się.",
  "Invalid pesel": "Podany numer pesel jest nieprawidłowy."
};

export function get_error_message(e) {
  var message = ERROR_MESSAGES[e.message];
  if (message) {
    return message;
  }
  if (e.message.includes("Invalid length for parameter Password")) {
    return ERROR_MESSAGES["Invalid length for parameter Password"];
  }
  return e.message;
}
